// extracted by mini-css-extract-plugin
export var boxItems = "_21-1";
export var boxItemsLg = "_21-2";
export var button = "_21-7";
export var buttonLg = "_21-8";
export var filterGroupBox = "_21-0";
export var icon = "_21-3";
export var iconSecondary = "_21-6";
export var iconWrapper = "_21-4";
export var iconWrapperLg = "_21-5";